/*
xu.ruliang 2017/04/13
 */
"use strict";
angular.module('manageSysManagesystemManagementModule', ['newWindowManageSysManagesystemManagementModule'])
    .controller('manageSysManagesyStemManagementModuleCtrl', ['$scope', '$modal', 'trsHttpService', 'modalDialog', 'trsspliceString', function($scope, $modal, trsHttpService, modalDialog, trsspliceString) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1,
            };
            $scope.status = {
                "copyCurrPage": 1
            };
            $scope.data = {
                items: [],
                selectedArray: []
            };
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData description]请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: 'mlf_domaintoken',
                methodname: 'queryAllDomainToken',
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
            });
        }
        /**
         * [new description]新建
         * @return {[type]} [description]
         */
        $scope.new = function() {
            createOrEdit({ DOMAINTOKENID: 0 }, "新建");
        };
        /**
         * [xiugai 修改]
         * @return {[type]} [description]
         */
        $scope.xiugai = function(item) {
            createOrEdit(item, "修改");
        };
        /**
         * [createOrEdit 新建或修改]
         * @param  {[object]} item [description] 修改对象
         * @param  {[string]} type [description] 类型
         * @return {[type]} [description]
         */
        function createOrEdit(item, type) {
            windowOpen(item, function(result) {
                var params = {
                    serviceid: 'mlf_domaintoken',
                    methodname: 'saveDomainToken',
                    ObjectId: item.DOMAINTOKENID,
                    DomainName: result.DOMAINNAME,
                    Token: result.TOKEN,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType(type + '成功', "", "success", false, function() {
                        requestData();
                    });
                });
            });
        }
        /**
         * [windowOpen description] 新建修改弹窗
         * @return {[type]} [description]
         */
        function windowOpen(item, success) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/systemManagementModule/newWindowManagementModule/newWindowManagementModule_tpl.html",
                scope: $scope,
                windowClass: 'new-managesys-System-management-module',
                backdrop: true,
                controller: "newWindowManageSysManagesystemManagementCtrl",
                resolve: {
                    Params: function() {
                        return item;
                    }
                },
            });
            modalInstance.result.then(function(result) {
                success(result);
            });
        }
        /**
         * [shareDraft description]删除
         * @return {[type]} [description]
         */
        $scope.shareDraft = function(item) {
            var TokenIDs = angular.isDefined(item) ? item.DOMAINTOKENID : trsspliceString.spliceString($scope.data.selectedArray, "DOMAINTOKENID", ",");
            modalDialog.confirmModal('删除', '确定删除?', function() {
                var params = {
                    serviceid: 'mlf_domaintoken',
                    methodname: 'delDomainTokens',
                    DomainTokenIds: TokenIDs,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType('删除成功', "", "success", false, function() {
                        requestData();
                        $scope.data.selectedArray = [];
                    });
                });
            });
        };
        /**
         * [selectAll description] 列表全选按钮
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };
        /**
         * [selectDoc description] 列表单选按钮
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };
        /** [selectPageNum description] 每页显示的数据数量
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            requestData();
        };
        /**
         * [pageChanged description] 下一页 页面改变调取数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        /**
         * [jumpToPage description] 跳转页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

    }]);
